import React from 'react';

const MenuIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
    >
        <path d="M4 5h16"/>
        <path d="M4 12h16"/>
        <path d="M4 19h16"/>
    </svg>
);

export default MenuIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/MenuIcon.jsx